import { GstSummaryView } from '../../../../../store/dashboard/revenueVendorExpenses/types';

export const GST_SUMMARY_VIEWS = {
    REVENUE: 'REVENUE',
    EXPENSE: 'EXPENSE',
} as const satisfies Record<GstSummaryView, GstSummaryView>;

export const GST_RETURN_CODES = {
    GSTR1: 'GSTR1',
    GSTR2A: 'GSTR2A',
    GSTR3B: 'GSTR3B',
} as const;

export const GST_RETURN_LABELS: Record<string, string> = {
    [GST_RETURN_CODES.GSTR1]: 'GSTR-1',
    [GST_RETURN_CODES.GSTR2A]: 'GSTR-2A',
    [GST_RETURN_CODES.GSTR3B]: 'GSTR-3B',
};

/** Sub-column order per view, used when the response carries no `returns`. */
export const DEFAULT_RETURNS_BY_VIEW: Record<GstSummaryView, string[]> = {
    REVENUE: [GST_RETURN_CODES.GSTR3B, GST_RETURN_CODES.GSTR1],
    EXPENSE: [GST_RETURN_CODES.GSTR2A, GST_RETURN_CODES.GSTR3B],
};

export const GST_SUMMARY_TITLE = 'GST Summary';

export const GST_DATA_SOURCES = {
    CONNECTED: 'CONNECTED',
    UPLOADED: 'UPLOADED',
} as const;

export const DATA_AVAILABLE_ROW_LABEL = 'Data Available';
export const NOT_AVAILABLE_LABEL = '-';

/** Row styling comes from the backend rowType (UW GST_RETURN_SUMMARY_ROW_TYPE), never from the label. */
export const SUMMARY_ROW_TYPES = {
    SEGMENT: 'segment',
    CREDIT_NOTE: 'creditNote',
    TOTAL: 'total',
} as const;
export const SUMMARY_TOTAL_HEADER_TYPE = 'total';
export const SUMMARY_PERIOD_HEADER_TYPE = 'period';
export const SUMMARY_CLASSIFICATION_HEADER_TYPE = 'classification';
export const SUMMARY_TOTAL_AMOUNTS_KEY = 'total';
export const GST_SUMMARY_POLL_INTERVAL_MS = 10000;
export const GST_SUMMARY_MAX_POLLS = 32;
export const GST_SUMMARY_PROCESSING_STATUS = 'PROCESSING';
export const GST_SUMMARY_ERROR_LABEL = 'Unable to load GST summary';
export const DATA_AVAILABILITY_TOOLTIP_LABEL = 'Data availability by GSTIN';
export const GST_SUMMARY_NO_DATA_LABEL = 'No data available';
export const GST_SUMMARY_PROCESSING_LABEL = 'Processing (may take ~2 mins)';
export const GST_SUMMARY_LOADING_LABEL = 'Loading GST summary';

/** Toggle options per view, in display order; the first one is the default selection. */
export const GST_RETURN_OPTIONS_BY_VIEW: Record<GstSummaryView, string[]> = {
    REVENUE: [GST_RETURN_CODES.GSTR3B, GST_RETURN_CODES.GSTR1],
    EXPENSE: [GST_RETURN_CODES.GSTR2A, GST_RETURN_CODES.GSTR3B],
};
